<template>
  <div id="date-time-format-ranger-on-table" class="d-flex flex-wrap">
    <DateTimeFormatOnTable :date="start" />
    <span class="wp-pre"> ~ </span>
    <DateTimeFormatOnTable :date="end" />
  </div>
</template>

<script>
import DateTimeFormatOnTable from './date-time-format-on-table.vue'
export default {
  components: {
    DateTimeFormatOnTable,
  },
  props: {
    start: {
      type: String,
      default: '',
    },
    end: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
#date-time-format-ranger-on-table {
  ::v-deep .wp-pre {
    white-space: pre;
  }
}
</style>
